import { gql } from 'apollo-angular'

export default gql`
  query username_conflict($username: String!, $id: Int!) {
    user(
      where: {
        username: { _eq: $username }
        status: { _neq: "deleted" }
        id: { _neq: $id }
      }
    ) {
      id
    }
  }
`
